import React, { Component } from "react";
import Content from "../../content/Content";
import SmartLink from "../shared/links/SmartLink";
import styles from "../../assets/css/modules/shared/thumbnail-list.css";

export class ThumbnailListItem extends Component {
  render() {
    let linkTo = this.props.LinkTo
      ? this.props.LinkTo
      : this.props.ExternalLinkTo;

    return (
      <div className={styles.thumbnailListItem}>
        <Content name={this.props.IconSrc}>
          {(imgSrc) => <img src={imgSrc} alt="" aria-hidden />}
        </Content>
        <div className={styles.thumbnailContent}>
          <h3>{this.props.Heading}</h3>
          <p>{this.props.Description}</p>
        </div>

        <SmartLink
          isExternalLink={!!this.props.ExternalLinkTo}
          to={linkTo}
          className={styles.thumbnailCardLink}
          aria-label={this.props.Heading}
        >
          {this.props.LinkText} <span className="ml-2">➔</span>
        </SmartLink>
      </div>
    );
  }
}

export default ThumbnailListItem;
